import { useState } from "react";
import { Alerts, Btn, P } from "../../../../AbstractElements";

const TimeAlert = () => {
  const [active, setActive] = useState(true);
  return (
    <Alerts color="default" isOpen={active} className={`border-warning alert-dismissible fade p-0`}>
      <div className="alert-arrow bg-warning">
        <i className="icon-timer" />
      </div>
      <P>
        {"Your time Over after "} <strong className="txt-dark">{"5"}</strong> {" minute"}
      </P>
      <Btn className="p-0 border-0 me-2 ms-auto" onClick={() => setActive(false)}>
        <span className="bg-warning px-3 py-1">{"Check"}</span>
      </Btn>
    </Alerts>
  );
};
export default TimeAlert;
